import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchFundingSourceDetails } from '../../actions/additional_actions';
import { FieldLike } from './utils';

class FundingSources extends Component {
    // static PropTypes = {
    //     fundingSource: PropTypes.array.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            contract: {},
        }

    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchFundingSourceDetails(contract.projectId, contract.contractId);

    }
    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchFundingSourceDetails(this.props.contract.projectId, this.props.contract.contractId);

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.fundingSource !== nextProps.fundingSource)
            this.setState({ fundingSource: nextProps.fundingSource })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    render() {
        const { fundingSource } = this.props;
        const className = 'row-wide project-info';

        return (
            <div id="info" className={className}>
                {fundingSource.length > 0 ?
                    <div className="clearfix">
                        {fundingSource.length > 0 ?

                            <div className="fsdetail">
                                
                                <div>
                                    <div className="col s12">
                                        <div className="col s12 m6">
                                            <FieldLike label="City Exempt" value={fundingSource[0].cityExempt} />
                                        </div>
                                        <div className="col s12 m6">
                                            <FieldLike label="State" value={fundingSource[0].state} />
                                        </div>
                                    </div>
                                    <div className="col s12">
                                        <div className="col s12 m6">
                                            <FieldLike label="Federal" value={fundingSource[0].fed} />
                                        </div>
                                        <div className="col s12 m6">
                                            <FieldLike label="City Non-Exempt" value={fundingSource[0].cityNonExempt} />
                                        </div>
                                    </div>
                                    <div className="col s12">
                                        <div className="col s12 m6">
                                            <FieldLike label="Other" value={fundingSource[0].other} />
                                        </div>

                                    </div>
                                </div>
                            </div> : null}
                    </div>
                    :
                    <div className="noData">
                        No Funding Source Details are found for this contract.
        </div>}
            </div>
        );
    }
}

FundingSources.propTypes = {
    fundingSource: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        fundingSource: state.additionalProjectsStore.fscDetail,
        projectId: ownProps.projectId,
    };
}

export default connect(mapStateToProps, { fetchFundingSourceDetails })(FundingSources);